
import React from 'react';

import OrderAdd from 'components/Order/Add';


export default function PlanningAdd(props) {
  return (
    <OrderAdd
      {...props}
      apiUrl={'planning'}
      basePath={'/planning'}
      documentTitle={'Новая перевозка'}
      headerTitle={'Создание перевозки'}
      extraItem={{ is_planing: true }}
    />
  );
}
